module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Erster Teil."), _c('br', {
    staticClass: "calibre6"
  }), _vm._v("\nLyrische und epische Form")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page19",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page20",
      "title": "wedi/Konmax"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "calibre4 sigil_not_in_toc"
  }, [_vm._v("Weltweh und Himmelssehnsucht")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wie eine Windesharfe"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsei deine Seele,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDichter!"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDer leiseste Hauch"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nbewege sie.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Und ewig müssen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Saiten schwingen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nim Atem des Weltwehs;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndenn das Weltweh"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nist die Wurzel"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder Himmelssehnsucht.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Also steht deiner Lieder"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nWurzel begründet"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nim Weh der Erde;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndoch ihren Scheitel krönet"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nHimmelslicht.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0